document.addEventListener('DOMContentLoaded', function() {
  var links = document.links;
  for (let i = 0, linksLength = links.length; i < linksLength; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = '_blank';
      links[i].rel = 'noopener noreferrer';
    }
  }

  var buttons = document.querySelectorAll('a.button, .btn a');
  buttons.forEach(function(button) {
    if (button.hostname !== window.location.hostname) {
      button.target = '_blank';
      button.rel = 'noopener noreferrer';
    }
  });
});
